module.exports = __webpack_public_path__ + "media/images/front/pc/features/search/doctors/header-ec9ec0953523c84405579493448379d9.png";